<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 名稱|云序號" @search="searchEvent" :showGj="false">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加打印机</el-button>
					<!-- <el-button type="warning" v-auth="'add'+auth_val" @click="openModel(2)" size="mini">出库</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="分類名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索产品名稱"></el-input>
						</el-form-item>
						
					
			
						<el-form-item label="项目類型" class="mb-0">
							<el-select v-model="from.parent_type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="销售成本" :value="1"></el-option>
								<el-option label="管理成本" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="对应产品" class="mb-0">
							<el-select v-model="from.is_product" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="不需要" :value="0"></el-option>
								<el-option label="需要" :value="1"></el-option>
							</el-select>
						</el-form-item>
						
					


						<el-form-item label="時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column>
			
				
			
		
				
				<el-table-column align="center" prop="name" label="打印机名稱">
				</el-table-column>
				
				<el-table-column align="center" prop="code" label="打印机云序號">
				</el-table-column>
				
				
			
			
				
		
				
				<el-table-column align="center" prop="num" 
width="280"  label="打印机狀態">
					<template slot-scope="v">
						<el-button size="mini" :disabled="checkload" plain type="success" @click="checkPrintStatus(v.row)">點擊查询</el-button>
						
						<span class="ml-3" v-show="checkload">
							<i class="el-icon-loading"></i>
							查询中
						</span>
						
						<span  class="ml-3" >
						
						<span style="color: #F56C6C;" v-if="v.row.status_type==0" > {{v.row.status_name}}</span>
						<span style="color: #67C23A;" v-if="v.row.status_type==1" > {{v.row.status_name}}</span>
						<span style="color: #E6A23C;" v-if="v.row.status_type==2" > {{v.row.status_name}}</span>
						</span>
						
						
						
						<!-- <span style="color: #999;" v-if="v.row.is_product==0">不需要</span>
						<span style="color: #67C23A;" v-else> 需要</span> -->

						
					</template>
				</el-table-column>
				
				
				
	
			
		
				
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="80" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							編輯
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">操作</el-button>
							
						

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加打印机':'修改打印机'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				<el-form-item label="打印机名稱" prop="name">
					<el-input type="text" v-model="form.name" 
					placeholder="打印机名稱" 
					clearable size="small" style="width: 85%;">
					
					</el-input>
				</el-form-item>
				
				<el-form-item label="云序號" prop="code">
					<el-input type="text" v-model="form.code" 
					placeholder="打印机云序號" 
					clearable size="small" style="width: 85%;">
					
					</el-input>
				</el-form-item>
				
			
				
				
				
			
			
				
		
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					name: [{
							required: true,
							message: "打印机名稱不能為空",
							trigger: 'blur',
						},
					],
					code: [{
							required: true,
							message: "打印机云序號不能為空",
							trigger: 'blur',
						},
					],
				
					
					
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name:"",
					parent_type:-1,
					is_product:-1,
					time: [],
				},
				model_title: 'Print',
				auth_val: 'Print',
				preUrl: "data/printList", //列表地址
				addUrl: "data/addPrint", //添加/修改地址
				editStatusUrl: "data/editStatusPrint", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					name:"",
					code:'',
					
				},
				prop: 'create_time',
				sort: 'descending',
				slist: [],
				plist: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				checkload:false,
				
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('pnumList');
		},
		methods: {
			
			checkPrintStatus(e){
				
				this.checkload = true;
				this.axios.post('/admin/data/checkPrintStatus', {
					code: e.code,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
					
					e.status_type = list.code
					e.status_name = list.msg
					
					
					//this.test1(e,list.msg)
					this.checkload = false;
				}).catch(err => {
					// 失敗
					this.checkload = false;
				})
				
			},
			
			
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
				
					this.slist = list.slist
					this.plist = list.plist
			
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						
					// 	if(!this.form.head){
					// 		this.$message.error('請傳入店铺图片');
					// 		return false
					// 	}
					
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						name: e.name,
						code:e.code,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						name:"",
						code:'',
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name:"",
					parent_type:-1,
					is_product:-1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
